<p class="text-surface-500 mb-4">We're always trying to improve Homey, and would love to hear your thoughts. What's working well, what could be better, or any improvements we could make? If you have questions or are in need of support look under the support tab instead.</p>

<homey-custom-form submitButtonLabel="Send feedback" [formGroup]="form" [submitFunction]="submit" buttonSize="small">
  <p-floatlabel variant="on" class="mb-2">
    <textarea
      pTextarea
      id="feedback-message"
      formControlName="message"
      rows="8"
      class="w-full resize-none"
    ></textarea>
    <label for="feedback-message">Your feedback</label>
  </p-floatlabel>
  <p-button additionalButtons size="small" severity="secondary" label="Cancel" (onClick)="onClose()"/>
</homey-custom-form>
